<ion-content>
    <div class="container">
        <client-recipe-card *ngFor="let recipe of recipes" [recipe]="recipe"></client-recipe-card>
    </div>

    <app-footer></app-footer>
</ion-content>
